<template>
  <div id="lever-record">
    <div class="title">
      <span class="fl">usdt</span>
      <span class="fr" @click="$router.go(-1)">返回</span>
    </div>
    <div class="list">
      <div class="list-title flex">
        <span>数量</span>
        <span>记录</span>
        <span>时间</span>
      </div>
      <ul>
        <li v-for="(item,index) in log" :key="index">
          <span>{{item.value}}</span>
          <!-- <span>{{item.info}}</span> -->
		  <span v-if="item.en_info == 1">{{$t('song.jgsxf')}}</span>
		  <span v-else-if="item.en_info == 2">{{$t('song.jgbj')}}</span>
		  <span v-else-if="item.en_info == 3">{{$t('song.jgks')}}</span>
		  <span v-else-if="item.en_info == 4">{{$t('song.jgyl')}}</span>
		  <span v-else-if="item.en_info == 5">{{$t('song.htcz')}}</span>
		  <span v-else-if="item.en_info == 6">{{$t('song.htshcz')}}</span>
		  <span v-else-if="item.en_info == 7">{{$t('song.bbhr')}}</span>
		  <span v-else-if="item.en_info == 8">{{$t('song.bbhc')}}</span>
		  <span v-else-if="item.en_info == 9">{{$t('song.pccl')}}</span>
		  <span v-else-if="item.en_info == 10">{{$t('song.gmsxf')}}</span>
		  <span v-else-if="item.en_info == 11">{{$t('song.ggsxf')}}</span>
		  <span v-else-if="item.en_info == 12">{{$t('song.ggbzj')}}</span>
		  <span v-else-if="item.en_info == 13">{{$t('song.gbdj')}}</span>
		  <span v-else-if="item.en_info == 14">{{$t('song.gbkc')}}</span>
		  <span v-else-if="item.en_info == 15">{{$t('song.gsdj')}}</span>
		  <span v-else-if="item.en_info == 16">{{$t('song.gskc')}}</span>
		  <span v-else-if="item.en_info == 17">{{$t('song.tbsbjs')}}</span>
		  <span v-else-if="item.en_info == 18">{{$t('song.tbsbch')}}</span>
		  <span v-else-if="item.en_info == 19">{{$t('song.tbcg')}}</span>
		  <span v-else-if="item.en_info == 20">{{$t('song.gyf')}}</span>
		  <span v-else-if="item.en_info == 21">{{$t('song.gghr')}}</span>
		  <span v-else-if="item.en_info == 22">{{$t('song.gghc')}}</span>
		  <span v-else-if="item.en_info == 23">{{$t('song.tbdj')}}</span>
		  <span v-else-if="item.en_info == 24">{{$t('song.tbkc')}}</span>
		  <span v-else-if="item.en_info == 25">{{$t('song.mhxh')}}</span>
		  <span v-else-if="item.en_info == 26">{{$t('song.mhhq')}}</span>
		  <span v-else-if="item.en_info == 27">{{$t('song.msxf')}}</span>
		  <span v-else-if="item.en_info == 28">{{$t('song.mbj')}}</span>
		  <span v-else-if="item.en_info == 29">{{$t('song.mks')}}</span>
		  <span v-else-if="item.en_info == 30">{{$t('song.myl')}}</span>
		  <span v-else-if="item.en_info == 31">{{$t('song.mhr')}}</span>
		  <span v-else-if="item.en_info == 32">{{$t('song.mhc')}}</span>
		  <span v-else-if="item.en_info == 33">{{$t('song.sfsczj')}}</span>
		  <span v-else-if="item.en_info == 34">{{$t('song.sfsckc')}}</span>
		  <span v-else-if="item.en_info == 35">{{$t('song.sczj')}}</span>
		  <span v-else-if="item.en_info == 36">{{$t('song.sckc')}}</span>
		  <span v-else-if="item.en_info == 37">{{$t('song.scsy')}}</span>
		  <span v-else-if="item.en_info == 38">{{$t('song.ahtcz')}}</span>
		  <span v-else-if="item.en_info == 39">{{$t('song.xcbx')}}</span>
		  <span v-else-if="item.en_info == 40">{{$t('song.bbjx')}}</span>
		  <span v-else-if="item.en_info == 41">{{$t('song.bbth')}}</span>
		  <span v-else-if="item.en_info == 42">{{$t('song.wtcd_t')}}</span>
		  <span v-else-if="item.en_info == 43">{{$t('song.wtcd_b')}}</span>
		  <span v-else-if="item.en_info == 44">{{$t('song.bxju_p')}}</span>
		  <span v-else-if="item.en_info == 45">{{$t('song.bxju_s')}}</span>
		  <span v-else-if="item.en_info == 46">{{$t('song.bxju_b')}}</span>
          <span>{{item.created_time}}</span>
        </li>
      </ul>
    </div>
    <div @click="getLog" class="loadmore">加载更多</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      log: [],
      page: 1
    }
  },
  created() {
    this.getLog();
  },
  methods: {
    getLog:function() {
      var id = this.$route.query.id;
      var token = window.localStorage.getItem("token");
      this.$http({
        url: "/api/wallet/legal_log",
        method: "post",
        headers: { Authorization: token },
        data: {
          type: "lever",
          currency: id
        }
      }).then(res => {
        if (res.data.type == "ok") {
          let msg = res.data.message;
          if (msg.list.length) {
            this.log.concat(msg.list);
            this.page += 1;
          } else {
            layer.msg("没有更多了");
          }
        }
      });
    }
  }
};
</script>

<style lang='scss'>
#lever-record {
  width: 1200px;
  margin: 0 auto;
  color: #c7cce6;
  .title {
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    margin: 20px 0;
    font-size: 20px;
    border-radius: 3px;
    background-color: #1a243b;
    span {
      cursor: pointer;
    }
  }
  .list {
    min-height: 900px;
    padding: 0 30px;
    background: #1a243b;
  }
  .list-title,
  li {
    display: flex;
    line-height: 40px;
    justify-content: space-between;
    span {
      flex: 1;
      text-align: center;
    }
  }
  li {
    border-top: 1px solid #202a4a;
  }
  .loadmore {
    text-align: center;
    padding: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/lever/leverRecord.vue